import { Position } from '../core.models'

export function distance(p1: Position, p2: Position): number {
    return (((Math.acos(
        Math.sin((p2.latitude * Math.PI / 180.0)) * Math.sin((p1.latitude * Math.PI / 180.0)) + Math.cos((p2.latitude * Math.PI / 180.0)) * Math.cos((p1.latitude * Math.PI / 180.0)) * Math.cos(
            ((p2.longitude - p1.longitude) * Math.PI / 180.0)
        )
    ))*180.0/ Math.PI)*60*1.1515*1.609344)
}
